import React from 'react';
import Header from '../components/Header';

const شروطالاستخدام = () => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      <Header />
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box'
      }}>
        <h1 style={{
          fontFamily: 'El Messiri, sans-serif',
          fontSize: '24px',
          fontWeight: 700,
          color: '#FFFFFF',
          margin: '0 0 8px 0',
          textAlign: 'right'
        }}>
          شروط الاستخدام
        </h1>

        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '40px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '14px',
            lineHeight: '1.8',
            color: '#2B2F3F',
            textAlign: 'right'
          }}>
            <p style={{ marginBottom: '24px', color: '#666A7A' }}>
              آخر تحديث: {new Date().toLocaleDateString('ar-SA')}
            </p>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                1. القبول
              </h2>
              <p>
                باستخدامك لتطبيق Min Bayty، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام التطبيق.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                2. استخدام التطبيق
              </h2>
              <p style={{ marginBottom: '12px' }}>
                يجب عليك:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>استخدام التطبيق للأغراض القانونية فقط</li>
                <li>عدم محاولة الوصول غير المصرح به إلى التطبيق</li>
                <li>عدم إرسال محتوى ضار أو غير قانوني</li>
                <li>احترام حقوق الملكية الفكرية</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                3. الحسابات
              </h2>
              <p style={{ marginBottom: '12px' }}>
                أنت مسؤول عن:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>الحفاظ على سرية معلومات حسابك</li>
                <li>جميع الأنشطة التي تحدث تحت حسابك</li>
                <li>إبلاغنا فوراً عن أي استخدام غير مصرح به</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                4. الطلبات والدفعات
              </h2>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>جميع الطلبات تخضع للتوفر</li>
                <li>الأسعار قابلة للتغيير دون إشعار</li>
                <li>نحتفظ بالحق في رفض أو إلغاء أي طلب</li>
                <li>الدفعات تتم عبر بوابات دفع آمنة</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                5. الملكية الفكرية
              </h2>
              <p>
                جميع المحتويات في التطبيق (النصوص، الصور، الشعارات، إلخ) محمية بحقوق الطبع والنشر وهي ملك لـ Min Bayty أو مقدمي المحتوى.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                6. إخلاء المسؤولية
              </h2>
              <p>
                نحن لا نضمن أن التطبيق سيكون خالياً من الأخطاء أو متاحاً بشكل مستمر. نحن غير مسؤولين عن أي أضرار ناتجة عن استخدام التطبيق.
              </p>
            </section>

            <section>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                7. التعديلات
              </h2>
              <p>
                نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إشعارك بأي تغييرات مهمة.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default شروطالاستخدام;




